import './App.css';
import Homepage from '../src/pages/HomePage';
function App() {
	return (
		<div className="App">
			<Homepage />
		</div>
	);
}

export default App;
